module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6RlLM"))).then(() => parcelRequire('37nVf'));